import React from 'react';

export default function RightArrowSVG({
  className = '',
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 12 9"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="12" height="9" fill="#FAFAFA" />
      <rect
        x="-946.393"
        y="-273.623"
        width="1366"
        height="918"
        fill="#F7F7F9"
      />
      <g filter="url(#filter0_d_2773_600)">
        <path
          d="M-766.393 -184.703C-766.393 -187.465 -764.155 -189.703 -761.393 -189.703H399.607C402.368 -189.703 404.607 -187.465 404.607 -184.703V629.297C404.607 632.058 402.368 634.297 399.607 634.297H-761.393C-764.155 634.297 -766.393 632.058 -766.393 629.297V-184.703Z"
          fill="white"
        />
      </g>
      <path
        d="M8.10094 0.260125C8.06508 0.217129 8.02066 0.182076 7.97051 0.1572C7.92035 0.132325 7.86557 0.118172 7.80964 0.115645C7.75371 0.113118 7.69787 0.122272 7.64568 0.142523C7.59349 0.162774 7.54608 0.193679 7.5065 0.233266C7.46691 0.272853 7.43601 0.320254 7.41575 0.372447C7.3955 0.424641 7.38635 0.480481 7.38888 0.536409C7.3914 0.592336 7.40556 0.647124 7.43043 0.697278C7.45531 0.747432 7.49036 0.791853 7.53336 0.827709L10.4292 3.72692H0.85744C0.754113 3.73241 0.656825 3.77731 0.585623 3.85239C0.514422 3.92747 0.474731 4.027 0.474731 4.13048C0.474731 4.23395 0.514422 4.33348 0.585623 4.40856C0.656825 4.48364 0.754113 4.52855 0.85744 4.53403H10.4292L7.52882 7.42984C7.45582 7.50629 7.41508 7.60793 7.41508 7.71363C7.41508 7.81934 7.45582 7.92097 7.52882 7.99742C7.56604 8.03477 7.61027 8.06439 7.65897 8.08461C7.70767 8.10483 7.75988 8.11523 7.81261 8.11523C7.86534 8.11523 7.91755 8.10483 7.96624 8.08461C8.01494 8.06439 8.05917 8.03477 8.0964 7.99742L11.6835 4.4103C11.7217 4.37355 11.7521 4.32947 11.7728 4.28071C11.7936 4.23194 11.8043 4.1795 11.8043 4.1265C11.8043 4.07351 11.7936 4.02106 11.7728 3.9723C11.7521 3.92354 11.7217 3.87946 11.6835 3.84271L8.10094 0.260125Z"
        fill="black"
      />
      <defs>
        <filter
          id="filter0_d_2773_600"
          x="-773.42"
          y="-196.73"
          width="1185.05"
          height="838.054"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.51351" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2773_600"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2773_600"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
